import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs';
import { Adb2cService } from './services/adb2c/adb2c.service';

@Injectable()
export class Adb2cAuthorisationInterceptor implements HttpInterceptor {
   constructor(private adb2cService: Adb2cService) {}

   intercept(req: HttpRequest<any>, next: HttpHandler) {
      // first check if interception is required
      const exclusions = [
         /^\/(client|umbraco|api)\//, //starts with /client/, /umbraco/, or /api/
         /.*\.(html|js|css|htm|jpg|jpeg|png)$/, //exclude by file extension
         /^https:\/\/api.worldpay.com/, //exclude worldpay requests
      ];

      // Handle both absolute and relative URLs
      const url = req.url.startsWith('http') ? req.url : `${window.location.origin}${req.url}`;
      const urlObj = new URL(url);
      const path = urlObj.pathname;

      for (let i = 0; i < exclusions.length; i++) {
         if (path.toLowerCase().match(exclusions[i])) {
            //  console.log('[ADB2C] token not required: ' + path.toLowerCase());

            // For /api/* endpoints, ensure cookies are sent
            if (path.startsWith('/api/')) {
               const authReq = req.clone({ withCredentials: true });
               return next.handle(authReq);
            }

            //return unaltered request
            return next.handle(req);
         }
      }

      if (path.includes('access_token')) {
         const authReq = req.clone({ withCredentials: true });

         return next.handle(authReq);
      }

      console.log('[ADB2C] attaching token to : ' + path.toLowerCase());
      return this.adb2cService.getAccessToken().pipe(
         switchMap((claim: string) => {
            // use transformation operator that maps to an Observable<T>
            const authReq = req.clone({ setHeaders: { Authorization: `Bearer ${claim}` } });

            return next.handle(authReq);
         })
      );
   }
}
